<template>
  <ul class="nav float-right account-btns" ref="topmenu">
    <li class="dropdown">
      <a
          id="navbarDropdown"
          class="dropdown-toggle"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
      >
        <span>
          <i class="fa fa-1-5x fa-globe"></i>
        </span>
      </a>
      <div
          class="dropdown-menu lg-dropdown-menu"
          aria-labelledby="navbarDropdown"
      >
        <a
            v-for="(lang, index) in getAvailableLanguages"
            :key="index"
            href="javascript:void(0)"
            class="dropdown-item pl-0"
            @click="setLocale(lang.locale)"
        >{{ lang.name }}</a
        >
      </div>
    </li>
    <li
        v-if="
        getUsedLifeStyles.allergies.length > 0 ||
        getUsedLifeStyles.intolerances.length > 0 ||
        getUsedLifeStyles.preferences.length > 0
      "
        class="dietary"
    >
      <a
          id="dietaryNavbarDropdown"
          v-if="!isGift"
          href="#"
          role="button"
          @click="openDietary()"
      >
        <span>
          <i class="fa fa-1-5x sliders-abacus"></i>
        </span>
      </a>
      <div
          :class="
          isLoginEnabled && this.isBranded()
            ? 'dietary-container no-margin'
            : 'dietary-container with-margin'
        "
          v-show="showDietary"
      >
        <div>
          <div
              v-for="allergy in getUsedLifeStyles.allergies"
              :key="'allergy' + allergy.Id"
          >
            <label class="checkbox-label d-flex">
              <div
                  class="dietary-icon"
                  :style="getIconStyle(allergy)"
              ></div>
              <input
                  type="checkbox"
                  :checked="allergy.isSelected"
                  @click="allergyChecked(allergy)"
              />
              <span
                  class="checkbox-checkmark right"
                  :style="getStyle()"
              ></span>
              {{ allergy.Name }}
            </label>
          </div>
          <div
              v-for="intolerance in getUsedLifeStyles.intolerances"
              :key="'intolerance' + intolerance.Id"
          >
            <label class="checkbox-label d-flex">
              <div
                  class="dietary-icon"
                  :style="getIconStyle(intolerance)"
              ></div>
              <input
                  type="checkbox"
                  :checked="intolerance.isSelected"
                  @click="intoleranceChecked(intolerance)"
              />
              <span
                  class="checkbox-checkmark right"
                  :style="getStyle()"
              ></span>
              {{ intolerance.Name }}
            </label>
          </div>
          <div
              v-for="preference in getUsedLifeStyles.preferences"
              :key="'preference' + preference.Id"
          >
            <label class="checkbox-label d-flex">
              <div
                  class="dietary-icon"
                  :style="getIconStyle(preference)"
              ></div>
              <input
                  type="checkbox"
                  :checked="preference.isSelected"
                  @click="preferencesChecked(preference)"
              />
              <span
                  class="checkbox-checkmark right"
                  :style="getStyle()"
              ></span>
              {{ preference.Name }}
            </label>
          </div>
        </div>
        <a class="clear-all" @click="clearAllDietarySelection()">{{
            $t("message.ClearAll")
          }}</a>
      </div>
    </li>
    <!--    <li v-if="user && !isGift" class="dropdown">-->
    <!--      <a-->
    <!--        id="navbarDropdown"-->
    <!--        class="dropdown-toggle"-->
    <!--        href="#"-->
    <!--        role="button"-->
    <!--        data-toggle="dropdown"-->
    <!--        aria-haspopup="true"-->
    <!--        aria-expanded="false"-->
    <!--      >-->
    <!--        <span class="material-icons">person</span>-->
    <!--        {{ user.email }}-->
    <!--      </a>-->
    <!--      <div-->
    <!--        class="dropdown-menu"-->
    <!--        aria-labelledby="navbarDropdown"-->
    <!--        ref="userdropdown"-->
    <!--      >-->
    <!--        <router-link class="dropdown-item" to="/profile">-->
    <!--          {{ $t("message.myAccount") }}-->
    <!--        </router-link>-->
    <!--        <router-link-->
    <!--          v-if="storeSupportsLoyaltyPoints"-->
    <!--          class="dropdown-item"-->
    <!--          :to="{-->
    <!--            name: useStampCollection ? 'userStamps' : 'loyalty',-->
    <!--            params: {-->
    <!--              storename: storeDoc,-->
    <!--            },-->
    <!--          }"-->
    <!--          >{{ $t("message.loyalty") }}</router-link-->
    <!--        >-->
    <!--        <router-link-->
    <!--          class="dropdown-item"-->
    <!--          :to="{-->
    <!--            name: 'orderhistory',-->
    <!--            params: {-->
    <!--              storename: storeDoc,-->
    <!--            },-->
    <!--          }"-->
    <!--          >{{ $t("message.orderHistory") }}</router-link-->
    <!--        >-->
    <!--        <router-link-->
    <!--          class="dropdown-item"-->
    <!--          :to="{-->
    <!--            name: 'ordertracking',-->
    <!--            params: {-->
    <!--              storename: storeDoc,-->
    <!--            },-->
    <!--          }"-->
    <!--          >{{ $t("message.orderTracking") }}</router-link-->
    <!--        >-->
    <!--        <a class="dropdown-item" href="#" @click="signOut">-->
    <!--          {{ $t("message.logOut") }}-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </li>-->
    <!--    <li-->
    <!--      v-if="!user && isLoginEnabled && this.isBranded() && !isGift"-->
    <!--      class="dropdown"-->
    <!--    >-->
    <!--      <a-->
    <!--        @click.prevent="openLoginOverlay"-->
    <!--        class="cursorPointer"-->
    <!--        style="display:block"-->
    <!--      >-->
    <!--        <span class="material-icons">person</span>-->
    <!--        {{ $t("message.logIn") }}-->
    <!--      </a>-->
    <!--    </li>-->
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { $$ } from "./../../sharedscripts/OO_jquery";
import { Validator } from "vee-validate";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import {
  IsStoreOpenAtTime,
  getCurrentDate,
} from "./../../api/helpers/datetimeHelper.js";

export default {
  name: "IntroLogin",
  data() {
    return {
      showDietary: false,
      isFromHomePage: false,
      storeOpen: false,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "giftCartValue",
      "getTotalPrice",
      "deliveryFee",
      "hqDoc",
      "currentstore",
      "isGift",
      "currentStoreDoc",
      "useStampCollection",
      "desktopStyles",
      "getAvailableLanguages",
      "getUsedLifeStyles",
      "getDietarySelection",
      "isDigitalDisplay",
      "storeSupportsLoyaltyPoints",
    ]),
    cartTotal() {
      return this.isGift
          ? this.giftCartValue
          : this.isFromHomePage
              ? this.getTotalPrice - this.deliveryFee
              : this.getTotalPrice;
    },
    ShowStoreLink() {
      return !this.isGift && this.isBranded();
    },
    storeDoc() {
      return this.currentStoreDoc ? this.currentStoreDoc.ID : this.currentstore;
    },
    isStoreOpen() {
      var storeOpen = false;
      if (this.currentStoreDoc) {
        var now = getCurrentDate(this.currentStoreDoc.TimezoneIanaFormat);
        storeOpen =
            (IsStoreOpenAtTime(
                    this.currentStoreDoc.OperatingHours,
                    this.currentStoreDoc.IsInOperation,
                    now
                ) ||
                this.currentStoreDoc.EnablePreoderForDelivery ||
                this.currentStoreDoc.EnablePreoderForPickup) &&
            this.currentStoreDoc.IsInOperation;
      }
      return storeOpen;
    },
    showCart() {
      if (
          this.$route.name &&
          this.$route.name.toLowerCase().indexOf("mainpage") < 0 &&
          this.$route.name.toLowerCase().indexOf("notfoundpage") < 0 &&
          this.$route.name.toLowerCase().indexOf("finalizesoregisteration") < 0 &&
          this.$route.name.toLowerCase().indexOf("registersouser") < 0
      )
        return true;
      return false;
    },
    isLoginEnabled() {
      if (this.hqDoc && this.hqDoc.ViewComponentConfigs) {
        return this.hqDoc.ViewComponentConfigs.LogIn || false;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.$root.$on("settopmenuFromHomePage", (val) => {
      this.isFromHomePage = val;
    });
    $$(".dropdown").hover(function () {
      $$(".dropdown-toggle").dropdown("hide");
    });
    this.SetObserve();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  watch: {
    user() {
      this.SetObserve();
    },
  },
  methods: {
    ...mapMutations([
      "setCurrentLocale",
      "setAllergySelected",
      "setIntoleranceSelected",
      "setPreferenceSelected",
    ]),
    ...mapActions(["logout"]),
    openLoginOverlay() {
      this.$root.$emit('open-overlay');
    },
    SetObserve() {
      if (this.user) {
        setTimeout(() => {
          this.observer = new MutationObserver((mutations) => {
            this.$nextTick(() => {
              this.openuserdropdown(mutations);
            });
          });
          this.observer.observe(this.$refs.userdropdown, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ["class"],
          });
        }, 500);
      } else {
        if (this.observer) this.observer.disconnect();
      }
    },
    signOut() {
      this.logout();
      var path = window.location.pathname;
      if (path.includes("profile")) this.navigateStore();
    },

    navigateStore() {
      let storeParam = this.storeDoc;
      var route = "store";
      this.$router.push({ name: route, params: { storename: storeParam } });
    },
    navigateShoppingcart() {
      if (this.isStoreOpen) {
        if (this.$route.name.toLowerCase().indexOf("checkout") >= 0) return;
        let storeParam = this.storeDoc;
        var route = "checkout";
        if (this.isGift) {
          route = "giftcardCheckout";
        }
        this.$router.push({ name: route, params: { storename: storeParam } });
      }
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      Validator.localize(locale, locale == "en" ? en : zh_CN);
      this.setCurrentLocale(locale);
    },
    clearAllDietarySelection() {
      this.setAllergySelected([]);
      this.setIntoleranceSelected([]);
      this.setPreferenceSelected([]);
    },
    openDietary() {
      this.showDietary = !this.showDietary;
      if (this.showDietary) {
        this.$refs.topmenu.style.zIndex = 10;
      } else {
        this.$refs.topmenu.style.zIndex = 5;
      }
    },
    openuserdropdown(miu) {
      miu[0].oldValue == "dropdown-menu"
          ? (this.$refs.topmenu.style.zIndex = 10)
          : (this.$refs.topmenu.style.zIndex = 5);
    },
    allergyChecked(dietary) {
      if (this.getDietarySelection.Allergy.some((s) => s.Id == dietary.Id)) {
        this.setAllergySelected(
            this.getDietarySelection.Allergy.filter((s) => s.Id != dietary.Id)
        );
      } else {
        this.setAllergySelected([...this.getDietarySelection.Allergy, dietary]);
      }
    },
    intoleranceChecked(intolerance) {
      if (
          this.getDietarySelection.Intolerance.some((s) => s.Id == intolerance.Id)
      ) {
        this.setIntoleranceSelected(
            this.getDietarySelection.Intolerance.filter(
                (s) => s.Id != intolerance.Id
            )
        );
      } else {
        this.setIntoleranceSelected([
          ...this.getDietarySelection.Intolerance,
          intolerance,
        ]);
      }
    },
    preferencesChecked(preferences) {
      if (
          this.getDietarySelection.Preference.some((s) => s.Id == preferences.Id)
      ) {
        this.setPreferenceSelected(
            this.getDietarySelection.Preference.filter(
                (s) => s.Id != preferences.Id
            )
        );
      } else {
        this.setPreferenceSelected([
          ...this.getDietarySelection.Preference,
          preferences,
        ]);
      }
    },
    getStyle() {
      var style = [];
      if (this.value) {
        style.push(this.desktopStyles.CommonColorBackground);
      } else {
        style.push(this.desktopStyles.pendingStatusBackground);
      }
      return style;
    },
    getIconStyle(item) {
      if (item && item.Name)
        return [
          {
            "background-image": `url(https://abacus-assets.firebaseapp.com/onlineordering/images/dietary/icon/abacus_dietary_${item.Name.split(
                " "
            ).join("")}.png)`,
          },
        ];
      else return [];
    },
  },
};
</script>
